import { Component } from '@angular/core';
import { NavParams, ViewController, ModalController } from 'ionic-angular';

/*
  Generated class for the ModalAdicionarPergunta page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-modal-servidores',
    templateUrl: 'modal-servidores.html'
})
export class ModalServidoresPessoalPage {

    objetoRetorno: any = {
        salvar: false,
        pessoal: ''
    };

    cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    pessoal: any;

    constructor(private viewCtrl: ViewController,
        public modalCtrl: ModalController,
        public navParams: NavParams) {

        this.objetoRetorno = {
            salvar: false,
            pessoal: ""
        };

        this.pessoal = this.navParams.get('pessoal');
    }
    dismiss() {
        this.objetoRetorno.salvar = false;
        this.viewCtrl.dismiss(this.objetoRetorno);
    }

    cpf_mask(v) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
    }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-servidores/modal-servidores.ts